import { UserLinkReqBody } from "api/types/user";
import { userLink } from "api/user";
import { notifySimple } from "providers/toast";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setLoading } from "store/appSlice";
import UserForm, { UserFormType } from "widgets/forms/users/user";
import GenericDialog from "./generic";

const AddUserDialog = (props: {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}) => {
  const { isOpen, onClose, onSuccess } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // Function for linking a user
  const doLinkUser = async (formData: UserFormType) => {
    dispatch(setLoading(true));
    const newUser: UserLinkReqBody = {
      email: formData.email,
      role: formData.role,
      classes: formData.classes,
    };
    const { status } = await userLink(newUser);
    dispatch(setLoading(false));
    if (status === 200) {
      onSuccess();
      notifySimple(t("notification.user.link.success"), "success");
    } else if (status === 401) {
      notifySimple(t("notification.user.link.error"), "error");
    } else {
      notifySimple(t("notification.user.link.failed"), "error");
    }
  };

  return (
    <GenericDialog
      isOpen={isOpen}
      onExit={onClose}
      title={t("dialog.add.user.title")}
    >
      <UserForm
        submit={doLinkUser}
        onClose={onClose}
      />
    </GenericDialog>
  );
};

export default AddUserDialog;
